import React from "react";
import {
  Box,
  Divider,
  Typography,
  Button,
  Card,
  TextField,
  Container,
  Drawer, Dialog, DialogTitle, DialogContent, DialogActions, Badge
} from "@mui/material";
import Account from "./Account";
import { useRef, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import WidgetsIcon from '@mui/icons-material/Widgets';
import CloseIcon from '@mui/icons-material/Close';
import { useUser } from "../../context/LoginDetail";
import { remove_account } from "../../api/authApi";
import { toast } from "react-toastify";

//this as a dashboard layout 
export default function ProfileScreen() {
  const [profileImage, setProfileImage] = React.useState(
    "/assets/images/profile2.png"
  );
  const [menuOpen, setMenuOpen] = React.useState(true);
  const [openMaterial, setOpenMaterial] = React.useState(false);
  const [openEnquiry, setOpenEnquiry] = React.useState(false);
  const [open, setOpen] = useState(false);

  // Open dialog
  const handleClickOpen = () => setOpen(true);

  // Close dialog
  const handleClose = () => setOpen(false);

  // Confirm delete
  const handleConfirmDelete = () => {

    remove_account(user?.id)
      .then((res) => {
        toast.success(res?.data.message || "Account Deleted Successfully")
        setOpen(false);

        localStorage.removeItem("authToken")
        localStorage.removeItem("user");
        localStorage.removeItem("phone")
        navigate('/')
      })
      .catch((err) => {

      });






  };

  // React.useEffect(() => {
  //   const handleResize = () => {
  //     // Only force open on large screens
  //     if (window.innerWidth >= 1200) {
  //       setMenuOpen(true);
  //     }
  //   };

  //   handleResize();
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);


  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1200) {
        setMenuOpen(true);
      }
      // else if (window.innerWidth >= 900) {
      //   setMenuOpen(true);
      // } 
      else {
        setMenuOpen(false);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  React.useEffect(() => {
    if (menuOpen && window.innerWidth < 1200) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen]);


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setProfileImage(url);
    }
  };

  const [selectedPage, setSelectedPage] = React.useState("Profile");
  const navigate = useNavigate();
  const location = useLocation();
  const { user, notificationCount } = useUser();
  const isVendorApproved = Number(user?.is_vendor) === 1;
  const isServiceApproved = Number(user?.is_services) === 1;


  // const items = [
  //   { name: "My Dashboard", img: "/assets/icons/setting.png", path: "my-dashboard" },
  //   { name: "My Profile", img: "/assets/icons/user.png", path: "account" },
  //   { name: "My MarketPlace Plot", img: "/assets/icons/residential_icon_menu.png", path: "my_markplace_plot" },
  //   {
  //   name: "Company Profile",img: "/assets/icons/materialsub.png",
  //   path: "material-vendor",

  //   subMenu: [
  //     ...(isVendorApproved
  //       ? [{ name: "Vendor", path: "material-vendor" }]
  //       : []),

  //     ...(isServiceApproved
  //       ? [{ name: "Service Provider", path: "material-service" }]
  //       : []),
  //   ],
  // },
  //   { name: "My Residential", img: "/assets/icons/residental_enquiry_icon.png", path: "my_residential_property" },
  //   { name: "MarketPlace Enquiry", img: "/assets/icons/marketingenquiry.png", path: "marketingplace-enquiry" },
  //   { name: "My Material Enquiry", img: "/assets/icons/material_enquiry.png", path: "material-enquiry" },
  //   { name: "My Service Enquiry", img: "/assets/images/headphones.png", path: "service-enquiry" },


  //   { name: "Residential Enquiry", img: "/assets/icons/add_property.png", path: "residential_enquiry" },
  //   { name: "Rental Enquiry", img: "/assets/icons/rental_icon.png", path: "rental_enquiry" },

  //   { name: "Buying List", img: "/assets/icons/buyinglist_icon.png", path: "buying-list" },
  //   { name: "Group Chat", img: "/assets/images/chat.png", path: "group-chat" },
  //   // { name: "About Us", img: "/assets/images/info.png", path: "about" },
  //   // { name: "Contact Us", img: "/assets/images/call.png", path: "contact" },
  // ];


  const companySubMenu = [
    ...(isVendorApproved || isServiceApproved
      ? [{ name: "My Company Profile", path: "/dashboard/company-profile" , img: "/assets/icons/company-vision.png"}]
      : []),
    ...(isServiceApproved
      ? [{ name: "My Service", path: "/dashboard/add-service", img: "/assets/icons/support1.png" }]
      : []),
    ...(isServiceApproved
      ? [{ name: "My Service Enquiry List", path: "/dashboard/my-service-enquiry", img: "/assets/images/headphones.png" }]
      : []),
    ...(isVendorApproved
      ? [{ name: "My Material", path: "/dashboard/add-material", img: "/assets/icons/technical-support.png" }]
      : []),
    ...(isVendorApproved
      ? [{ name: "My Material Enquiry List", path: "/dashboard/my-material-enquiry", img: "/assets/icons/material_enquiry.png" }]
      : []),
  ];

  const enquirySubMenu = [
    { name: "Land Enquiry", path: "/dashboard/marketingplace-enquiry", img: "/assets/icons/marketingenquiry.png" },
    { name: "Material Enquiry", path: "/dashboard/material-enquiry", img: "/assets/icons/material_enquiry.png" },
    { name: "Service Enquiry", path: "/dashboard/service-enquiry", img: "/assets/images/headphones.png" },
    { name: "Flats / Villas Enquiry", path: "/dashboard/residential_enquiry", img: "/assets/icons/add_property.png" },
    { name: "Rental Yield Enquiry", path: "/dashboard/rental_enquiry", img: "/assets/icons/rental_icon.png" },
  ];

  const items = [
    { name: "My Dashboard", img: "/assets/icons/setting.png", path: "/dashboard/my-dashboard" },
    { name: "Notifications", img: "/assets/icons/notifications.png", path: "/dashboard/notifications" },
    { name: "My Profile", img: "/assets/icons/user.png", path: "/dashboard/account" },
    { name: "My Wallet", img: "/assets/icons/Wallet.png", path: "/dashboard/my-wallet" },
    { name: "Gift/Payment Coupon", img: "/assets/icons/purchase_coupon.png", path: "/dashboard/purchase-coupon" },
    { name: "Encashment", img: "/assets/icons/encashment.png", path: "/dashboard/encashment" },
    ...(companySubMenu.length > 0
      ? [{
        name: "Company Profile",
        img: "/assets/icons/materialsub.png",
        path: "/dashboard/company-profile",
        subMenu: companySubMenu,
        isOpen: openMaterial,
        setOpen: setOpenMaterial
      }]
      : []),
    {
      name: "Enquiry List",
      
        img: "/assets/icons/materialsub.png",
      path: "/dashboard/marketingplace-enquiry",
      subMenu: enquirySubMenu,
      isOpen: openEnquiry,
      setOpen: setOpenEnquiry
    },
    { name: "My Land", img: "/assets/icons/residential_icon_menu.png", path: "/dashboard/my_markplace_plot" },
    { name: "My Flats / Villas", img: "/assets/icons/residental_enquiry_icon.png", path: "/dashboard/my_residential_property" },
    { name: "Buying List", img: "/assets/icons/buyinglist_icon.png", path: "/dashboard/buying-list" },
    { name: "KYC Details", img: "/assets/icons/KYC_Details.png", path: "/dashboard/kyc-details" },
    { name: "General Enquiry", img: "/assets/icons/material_enquiry.png", path: "/dashboard/general-enquiry" },
    { name: "Account Details", img: "/assets/icons/Wallet.png", path: "/dashboard/account-details" },
    { name: "Transactions", img: "/assets/images/info.png", path: "/dashboard/transactions" },
    // { name: "Group Chat", img: "/assets/images/chat.png", path: "/dashboard/group-chat" },
  ];


  const renderPage = () => {
    switch (selectedPage) {
      case "My Profile":
        return <Account />
      case "My Material Enquiry":
        return <h2>My Product Enquiry Page</h2>;

      case "My Service Enquiry":
        return <h2>My Service Enquiry Page</h2>;

      case "Group Chat":
        return <h2>Group Chat Page</h2>;

      case "About Us":
        return <h2>About Us Page</h2>;

      // case "Contact Us":
      //   return <h2>Contact Us Page</h2>;

      default:
        return <Account />;
    }
  };

  const sidebarRef = useRef();

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        window.innerWidth < 1200
      ) {
        setMenuOpen(false); // close sidebar if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <Container>
      <Box
        className="col-md-12"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          gap: 6,
          py: { xs: 2, md: 8 },
          justifyContent: "center",
          alignItems: { xs: "center", lg: "flex-start" },
          background: "white",
        }}>
        <Button
          onClick={() => setMenuOpen(!menuOpen)}
          sx={{
            display: { xs: "block", lg: "none" },
            mb: 2,
            px: 1,
            minWidth: "auto",
            alignSelf: "flex-start",
          }}>
          <WidgetsIcon alt="menu" style={{ width: 25 }} />
        </Button>

        <Card
          ref={sidebarRef}
          sx={{
            transition: "all 0.3s ease",
            transform: {
              xs: menuOpen ? "translateX(0)" : "translateX(-110%)",
              sm: menuOpen ? "translateX(0)" : "translateX(-110%)",
              md: menuOpen ? "translateX(0)" : "translateX(-110%)",
              // lg: "translateX(0)", // >=1200px always show
            },
            // transform: { xs: menuOpen ? "translateX(0)" : "translateX(-110%)", md: "translateX(0)" },
            position: { xs: "fixed", lg: "relative" },

            left: 0,
            bottom: 0,
            top: { xs: 64, lg: "auto" }, // ⬅ push below header
            height: { xs: "calc(100vh - 64px)", lg: "auto" },

            width: { xs: "70%", sm: "60%", md: "50%", lg: 300 },
            maxHeight: { xs: "100vh", lg: "100vh", xl: "none" },
            p: 3,

            borderRadius: 4,
            boxShadow: 4,
            border: "1px solid #e5e5e5",
            zIndex: { xs: 4800, md: 1000 },
            bgcolor: "white",
            overflowY: { xs: "auto", lg: "visible" },
            WebkitOverflowScrolling: "touch",
          }}
        >
          {/* CLOSE BUTTON */}
          {menuOpen && (
            <Box
              sx={{
                display: { xs: "flex", lg: "none" },
                justifyContent: "flex-end",
                alignItems: "center",
                px: 1
              }}
            >
              <Button
                onClick={() => setMenuOpen(false)}
                aria-label="Close menu"
                sx={{
                  minWidth: "auto",
                  mt: { xs: 0, md: 3, lg: 0 },
                  height: 36,
                  borderRadius: "50%",
                  color: "error.main",
                  fontSize: 20,
                  fontWeight: "bold",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "error.light",
                    color: "error.contrastText",
                    transform: "rotate(90deg)"
                  },
                  "&:active": {
                    transform: "scale(0.95)"
                  }
                }}
              >
                ✕
              </Button>
            </Box>
          )}

          {/* {menuOpen && (
            <Box sx={{ display: { xs: "flex", lg: "none" }, justifyContent: "flex-end" }}>
              <Button
                onClick={() => setMenuOpen(false)}
                sx={{
                  minWidth: "auto",
                  p: 1,
                  color: "red"
                }}
              >
                ✕
              </Button>
            </Box>
          )} */}

          {/* MENU ITEMS */}
          {/* <Box sx={{ mt: { xs: 2, md: 0 } }}>
            {items.map((item, i) => {
              const isActive = location.pathname.includes(item.path);
              return (
                <Box key={i}>
                  <Button
                    fullWidth
                    sx={{
                      justifyContent: "flex-start",
                      py: 1.5,
                      gap: 2,
                      textTransform: "none",
                      fontSize: 15,
                      color: isActive ? "primary.main" : "#444",
                      fontWeight: isActive ? 700 : 500,
                    }}
                    onClick={() => {
                      navigate(item.path);
                      if (window.innerWidth < 1200) {
                        setMenuOpen(false);
                      }
                    }}
                  >
                    <img src={item.img} alt="icon" style={{ width: 22 }} />
                    {item.name}
                  </Button>
                  <Divider sx={{ my: 1, borderBottom: "1px solid #c1c1c1" }} />
                </Box>
              );
            })}

         
          </Box> */}
          <Box sx={{ mt: { xs: 2, md: 0 } }}>
            {items.map((item, i) => {
              const isActive = location.pathname.includes(item.path);
              const hasSubMenu = item.subMenu && item.subMenu.length > 0;

              return (
                <Box key={i}>
                  {/* MAIN MENU */}
                  <Button
                    fullWidth
                    sx={{
                      justifyContent: "flex-start",
                      py: 1.5,
                      gap: 2,
                      textTransform: "none",
                      fontSize: 15,
                      color: isActive ? "primary.main" : "#444",
                      fontWeight: isActive ? 700 : 500,
                    }}
                    onClick={() => {
                      if (hasSubMenu) {
                        item.setOpen(prev => !prev);
                      } else {
                        navigate(item.path);
                        if (window.innerWidth < 1200) {
                          setMenuOpen(false);
                        }
                      }
                    }}
                  >
                    <img src={item.img} alt="icon" style={{ width: 22 }} />
                    <Box sx={{ flexGrow: 1, textAlign: "left" }}>
                      {item.name}
                    </Box>
                    {item.name === "Notifications" && notificationCount > 0 && (
                      <Badge
                        badgeContent={notificationCount}
                        color="error"
                        sx={{
                          "& .MuiBadge-badge": {
                            right: -5,
                            top: 10,
                          },
                        }}
                      />
                    )}
                  </Button>



                  {/* SUB MENU */}
                  {hasSubMenu && item.isOpen && (
                    <Box sx={{ pl: 5 }}>
                      {item.subMenu.map((sub, si) => {
                        const isSubActive = location.pathname.includes(sub.path);

                        return (
                          <Button
                            key={si}
                            fullWidth
                            sx={{
                              justifyContent: "flex-start",
                              py: 1,
                              fontSize: 14,
                              textTransform: "none",
                              color: isSubActive ? "primary.main" : "#666",
                              fontWeight: isSubActive ? 600 : 400,
                              gap: 1.5
                            }}
                            onClick={() => {
                              navigate(sub.path);
                              if (window.innerWidth < 1200) {
                                setMenuOpen(false);
                              }
                            }}
                          >
                            {sub.img ? <img src={sub.img} alt="icon" style={{ width: 16 }} /> : "▸"}
                            {sub.name}
                          </Button>
                        );
                      })}
                    </Box>
                  )}

                  <Divider sx={{ my: 1, borderBottom: "1px solid #c1c1c1" }} />
                </Box>
              );
            })}

            {/* <Button
              color="error"
              fullWidth
              sx={{
                justifyContent: "flex-start",
                py: 1.5,
                gap: 2,
                textTransform: "none",
                fontSize: 15,

                fontWeight: 500,
              }}
              onClick={handleClickOpen}

            >
              <img src={"/assets/images/delete.png"} alt="icon" style={{ width: 22 }} />
              Delete Account
            </Button> */}



            <Dialog open={open} onClose={handleClose}>
              <DialogTitle>Confirm Delete</DialogTitle>
              <DialogContent>
                <Typography>Are you sure you want to delete your account? This action cannot be undone.</Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleConfirmDelete} color="error">
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
          </Box>


        </Card>
        <Box sx={{ flex: 1, width: "100%" }}>
          <Outlet />
        </Box>
      </Box>
    </Container>

  );
}

